import BaseService from "./BaseService";
import AppUtils from "../utils/BaseUtils/AppUtils";

class CustomerServices extends BaseService {
  createCustomer(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.CREATE_CUSTOMER,
      payload,
      successAction,
      loaderType,
      errorType,
      showSuccessMessage,
      successCondition,
      getErrorMessage
    );
  }
  updateCustomer(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.UPDATE_CUSTOMER,
      payload,
      successAction,
      loaderType,
      errorType,
      showSuccessMessage,
      successCondition,
      getErrorMessage
    );
  }
  readCustomer(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.READ_CUSTOMER,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  readByCustomer(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.READ_BY_CUSTOMER,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  readTimezones(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.READ_TIMEZONES,
      payload,
      successAction,
      loaderType,
      errorType,
      false,
      successCondition,
      getErrorMessage
    );
  }
  uploadImage(
    payload,
    successAction,
    loaderType,
    errorType,
    showSuccessMessage,
    successCondition,
    getErrorMessage
  ) {
    return this.makePostRequest(
      AppUtils.urls.customer.UPLOAD_IMAGE,
      payload,
      successAction,
      loaderType,
      errorType,
      showSuccessMessage,
      successCondition,
      getErrorMessage
    );
  }
}

export default CustomerServices;
